import isEmpty from 'is-empty';
import {
  WITHDRAW_MT_LIP_INVESTMENT,
  WITHDRAW_MT_LIP_INVESTMENT_ERROR,
  WITHDRAW_MT_LIP_INVESTMENT_LOADING,
  WITHDRAW_MT_LIP_INVESTMENT_ERROR_DELETE
} from '../../../actions/types';

const initialState = {
  success: false,
  withdrawMtLip: {},
  error: '',
  loading: false
};

const withdrawMtLip = (state = initialState, action) => {
  switch (action.type) {
    case WITHDRAW_MT_LIP_INVESTMENT:
      return {
        ...state,
        success: !isEmpty(action.withdrawMtLip),
        withdrawMtLip: action.withdrawMtLip,
        loading: false
      };
    case WITHDRAW_MT_LIP_INVESTMENT_ERROR:
      return {
        ...state,
        success: false,
        error: action.error,
        loading: false
      };
    case WITHDRAW_MT_LIP_INVESTMENT_ERROR_DELETE:
      return {
        error: ''
      };
    case WITHDRAW_MT_LIP_INVESTMENT_LOADING:
      return {
        ...state,
        loading: true
      };
    default:
      return state;
  }
};

export default withdrawMtLip;
